export const GET_PROJECTS_LIST = 'GET_PROJECTS_LIST';
export const GET_PROJECTS_LIST_FAILED = 'GET_PROJECTS_LIST_FAILED';
export const DELETE_PROJECT_BY_ID = 'DELETE_PROJECT_BY_ID';
export const GET_PROJECT_BY_ID = 'GET_PROJECT_BY_ID';
export const GET_SALES_PERSONS_LIST = 'GET_SALES_PERSONS_LIST';
export const GET_CONTACTS = 'GET_CONTACTS';
export const GET_CONTACTS_FAILED = 'GET_CONTACTS_FAILED';


export function getContactsListFailed(data) {
  return {
    type: GET_CONTACTS_FAILED,
    payload: data,
  }
}

export function getContactsList(data) {
  return {
    type: GET_CONTACTS,
    payload: data,
  }
}

export function getProjectsList(data) {
  return {
    type: GET_PROJECTS_LIST,
    payload: data,
  }
}

export function getProjectsListFailed(data) {
  return {
    type: GET_PROJECTS_LIST_FAILED,
    payload: data,
  }
}

export function getProjectById(data) {
  return {
    type: GET_PROJECT_BY_ID,
    payload: data,
  }
}

export function deleteProjectById(data) {
  return {
    type: DELETE_PROJECT_BY_ID,
    payload: data,
  }
}

export function getSalesPersons(data) {
  return {
    type: GET_SALES_PERSONS_LIST,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/projects/index.js